<template>
	<page-container class="container container-contact no-heading-image" :page="page">
		<content-blocks v-if="page.contentblocks.length" :items="page.contentblocks" />

		<div class="contact-info">
			<p>
				<span>
					{{ defaults[locale].website.street }}
					{{ defaults[locale].website.number }}</span
				>
				<br />
				<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
				<br />
				<span>{{ defaults[locale].website.country }}</span>
				<br />
				<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
					<span>{{ defaults[locale].website.phone }}</span>
				</a>
				<br />
				<a :href="`mailto:${defaults[locale].website.email}`">
					<span>{{ defaults[locale].website.email }}</span>
				</a>
				<br />
			</p>
		</div>

		<div class="form-wrapper">
			<div class="row">
				<div class="columns column12 align-left">
					<h1>{{ page.title || page.header }}</h1>
					<div v-if="page.content" v-parse-links v-html="page.content" />
				</div>
				<div class="columns column12">
					<contact-form name="contact" :form="form" />
				</div>
			</div>
		</div>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

const { defaults, fetchDefaults } = useDefaults();

await fetchDefaults();
await fetchPage();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});

useHead({
	bodyAttrs: {
		class: 'contact',
	},
});
</script>

<style lang="scss" scoped>
.form-wrapper,
.content-section {
	.row {
		max-width: 760px;
		padding: 0 125px;
		margin-top: 190px;

		form > div,
		:deep(form > div) {
			width: 100%;
		}
	}
}

.contact-info {
	position: absolute;
	inset: 115px 50px auto auto;
	color: var(--secondary-background-color);
	font-size: 14px;
	line-height: 16px;

	a {
		color: var(--secondary-background-color);
	}
}

.content-section.maps {
	padding: 0 0 25px;
}

#maps {
	min-height: 600px;
}

h1 {
	margin-top: 30px;
}

.address {
	text-transform: uppercase;

	h2 {
		text-transform: none;
	}

	a {
		font-family: var(--body-font-family);
		font-weight: 400;
		text-decoration: none;
		font-size: var(--body-font-size);
	}
}

@media (max-width: 1280px) {
	.column6 {
		width: 100%;
	}

	.column2,
	.column4 {
		width: 50%;
	}
}

@media (max-width: 1080px) {
	.form-wrapper,
	.content-section {
		.row {
			margin-left: auto;
			padding: 0 20px;
		}
	}
}

@media (max-width: 640px) {
	.column2,
	.column4 {
		width: 100%;
	}
}
</style>
